import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { isArray } from "lodash";

import { bulkCheckAbruptCut, checkAbruptCut } from "./actions";

export const audioCutCheckEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.clip_id,
});

const initialState = audioCutCheckEntityAdapter.getInitialState({});

export const audioCutCheckSlice = createSlice({
  name: "audioCutCheck",
  initialState: initialState,
  reducers: {
    updateOneAudioCutCheckResult: (state, action) => {
      audioCutCheckEntityAdapter.updateOne(state, {
        id: action.payload.clip_id,
        changes: action.payload,
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(checkAbruptCut.fulfilled, (state, action) => {
      const clipSuggestion = { clip_id: action.meta.arg.payload.clip_id, ...action.payload };

      audioCutCheckEntityAdapter.setOne(state, clipSuggestion);
    });
    builder.addCase(bulkCheckAbruptCut.fulfilled, (state, action) => {
      if (!isArray(action.payload)) return;

      audioCutCheckEntityAdapter.upsertMany(state, action.payload);
    });
  },
});

export const { updateOneAudioCutCheckResult } = audioCutCheckSlice.actions;

export default audioCutCheckSlice.reducer;
